import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import {
  TextField,
  TextFieldProps,
} from '@beeline/design-system-react/extracted-styles';

import { FieldSkeleton } from '../FieldSkeleton/FieldSkeleton';

export interface FormTextFieldProps extends Omit<TextFieldProps, 'value'> {
  name: string;
  loading?: boolean;
}

export const FormTextField: FC<FormTextFieldProps> = ({
  name,
  loading,
  type,
  required,
  onChange,
  helperText,
  ...rest
}) => {
  const validate = useCallback(
    (value: string | undefined) => {
      if (required) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) return 'Заполните поле';
      }
    },
    [required],
  );
  const { input, meta } = useField(name, { type, validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      input.onChange(event);
      onChange?.(event);
    },
    [input, onChange],
  );

  return loading ? (
    <FieldSkeleton size={rest.size} />
  ) : (
    <TextField
      {...rest}
      {...input}
      error={!!error}
      helperText={error ?? helperText}
      type={type}
      required={required}
      onChange={handleChange}
    />
  );
};
